  @if (!loading) {
    <div class="routed-component-layout">
      <div class="routed-component-body">
        <div class="routed-component-title-block">
          <h2>{{ 'REGISTRATION.IDV_COMPLETE.TITLE' | translate }}</h2>
          <div class="image emailimage"></div>
        </div>
        @if (applicant) {
          <p>{{ 'REGISTRATION.IDV_COMPLETE.PARAGRAPH_1_APPLICANT' | translate : { email: applicant.email } }}</p>
          <p>{{ 'REGISTRATION.IDV_COMPLETE.PARAGRAPH_2_APPLICANT' | translate }}</p>
          <p>{{ 'REGISTRATION.IDV_COMPLETE.PARAGRAPH_3_APPLICANT' | translate }}</p>
        } @else {
            <p>{{ 'REGISTRATION.IDV_COMPLETE.PARAGRAPH_1' | translate }}</p>
            <p>{{ 'REGISTRATION.IDV_COMPLETE.PARAGRAPH_2' | translate }}</p>
        }

         <div class="navigation-controls-layout">
          <div class="idv-cta-section">
            <button class="primary centered" (click)="clickOnCTA()">{{ 'REGISTRATION.IDV_COMPLETE.CTA' | translate }}</button>
          </div>
        </div>
      </div>
    </div>
  }